/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum APIConstants {
  UNSTARTED = '@api/UNSTARTED',
  STARTED = '@api/STARTED',
  SUCCEEDED = '@api/SUCCEEDED',
  FAILED = '@api/FAILED',
  NODATA = '@api/NODATA'
}
